import Constants from './Constants.js';
import Auth from './auth/Auth.js';
import AuthReducer from './auth/AuthReducer.js';
import Interface from './interface/Interface.js';
import InterfaceReducer from './interface/InterfaceReducer.js';
import InterfaceActions from './interface/InterfaceActions.js';
import History from './query/HistoryActions.js';
import HistoryReducer from './query/HistoryReducer.js';
import Event from './query/EventActions.js';
import EventReducer from './query/EventReducer.js';
import * as QueryUtil from './query/util.js';
import Users from './users/Users.js';
import UsersReducer from './users/UsersReducer.js';
import defaultReducer from './Reducer.js';
import Project from './project/Project.js';
import System from './system/System.js';
import Device from './device/Device.js';
import Blueprint from './project/Blueprint.js';
import Blueprints from './project/Blueprints.js';
import BlueprintReducer from './project/BlueprintReducer.js';
import EnumReducer from './enums/EnumReducer.js';
import ResourceEnumReducer from './enums/ResourceEnumReducer.js';
import RoleReducer from './project/RoleReducer.js';
import ModuleReducer from './project/ModuleReducer.js';
import PermissionReducer from './project/PermissionReducer.js';
import ResourceUser from './users/ResourceUser.js';
import ResourceUsers from './users/ResourceUsers.js';
import ResourceUserReducer from './users/ResourceUserReducer.js';
import ResourceTemporaryUser from './temporaryUsers/ResourceTemporaryUser.js';
import ResourceTemporaryUsers from './temporaryUsers/ResourceTemporaryUsers.js';
import ResourceTemporaryUserReducer from './temporaryUsers/ResourceTemporaryUserReducer.js';
import AllowedReducer from './AllowedReducer.js';
import ApiProvider from "./ApiProvider.js";
import RsrcReducer from './rsrc/RsrcReducer.js';
import Rsrc from './rsrc/Rsrc.js';
import ApiUserSettingsDelegate from './rsrc/ApiUserSettingsDelegate.js';
import MaintenanceEvents from './maintenanceEvents/MaintenanceEvents.js';
import MaintenanceEvent from './maintenanceEvents/MaintenanceEvent.js';
import OidcClient from './project/OidcClient.js';
import OidcClients from './project/OidcClients.js';
import OidcClientReducer from './project/OidcClientReducer.js';
import MaintenanceEventReducer from './maintenanceEvents/MaintenanceEventReducer.js';
import Rule from './rule/Rule.js';
import Rules from './rule/Rules.js';
import RuleReducer from './rule/RuleReducer.js';
import ApiAccessKey from './apiAccessKey/ApiAccessKey.js';
import ApiAccessKeys from './apiAccessKey/ApiAccessKeys.js';
import ApiAccessKeyReducer from './apiAccessKey/ApiAccessKeyReducer.js';
import ClientIds from './clientId/ClientIds.js';
import ClientId from './clientId/ClientId.js';
import ClientIdReducer from './clientId/ClientIdReducer.js';
import Can from './interface/Can.js';
import Obj from './interface/Obj.js';

/**
 * Returns an object with all the reducers set to desired keys
 */
function getReducers() {
  return {
    auth: AuthReducer,
    users: UsersReducer,
    models: InterfaceReducer,
    history: HistoryReducer,
    events: EventReducer,
    enums: EnumReducer,
    resourceEnums: ResourceEnumReducer,
    resourceUsers: ResourceUserReducer,
    resourceTemporaryUsers: ResourceTemporaryUserReducer,
    blueprints: BlueprintReducer,
    allowed: AllowedReducer,
    roles: RoleReducer,
    modules: ModuleReducer,
    permissions: PermissionReducer,
    rsrcs: RsrcReducer,
    oidc: OidcClientReducer,
    maintenanceEvents: MaintenanceEventReducer,
    rules: RuleReducer,
    apiAccessKeys: ApiAccessKeyReducer,
    clientIds: ClientIdReducer
  };
}
export default {
  create: (system, fleet) => {
    return new Interface(system, fleet);
  }
};
const setInterfaceCacheTime = InterfaceActions.setCacheTime;
const getInterfaceCacheTime = InterfaceActions.getCacheTime;
export {
/**
 * creates a new Interface object
 * @constructor
 * @param {string} system - the system, systemId or system alias of the system that you are trying to connect to
 * @param {string} fleet - the type of device or group you are querying for
 */
Constants, InterfaceReducer as reducer, Interface, InterfaceReducer, InterfaceActions, setInterfaceCacheTime, getInterfaceCacheTime, defaultReducer, Auth, AuthReducer, Can, Obj, History, HistoryReducer, Event, EventReducer, Users, UsersReducer, Project, System, Device, Blueprint, Blueprints, BlueprintReducer, EnumReducer, ResourceEnumReducer, RoleReducer, ModuleReducer, PermissionReducer, MaintenanceEventReducer, ResourceUser, ResourceUsers, ResourceUserReducer, ResourceTemporaryUser, ResourceTemporaryUsers, ResourceTemporaryUserReducer, ApiAccessKey, ApiAccessKeys, ApiAccessKeyReducer, AllowedReducer, QueryUtil, ApiProvider, getReducers, Rsrc, RsrcReducer, OidcClient, OidcClients, OidcClientReducer, Rule, Rules, RuleReducer, ApiUserSettingsDelegate, MaintenanceEvents, MaintenanceEvent, ClientId, ClientIds, ClientIdReducer };